import { Injectable } from '@angular/core';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { ApiService }                from '../../api/api.service';
import { JobBulkPrintModel }         from './typings/transaction-center.jobs.bulk-print';
import { JobStartAndPrintComponent } from './transaction-center.jobs.start-and-print.component';
import { JobStartAndPrintTypeModel } from './typings/transaction-center.jobs.start-and-print-type';

@Injectable({
  providedIn: 'root'
})
export class JobsService {
  constructor (
    private apiService  : ApiService,
    private modalService: NgbModal
  ) {}

  bulkPrint ( bulkPrint : JobBulkPrintModel ) : Promise<any> {
    return this.apiService.post('/reports/jasper_job_card_bulk', bulkPrint, 'print', null, {
        responseType: 'arraybuffer'
      });
  }

  getEventsForDate ( date : string ) : Promise<any> {
    return this.apiService.get('/events/get_events_for_today', date);
  }

  getInvoicesForDate ( date : string ) : Promise<any> {
    return this.apiService.get('/invoices/get_jobs_for_today', date);
  }

  printForDate () : Promise<any> {
    return this.startAndPrint('printOnly');
  }

  startForDate () : Promise<any> {
    return this.startAndPrint('startOnly');
  }

  startAndPrintForDate () : Promise<any> {
    return this.startAndPrint('startAndPrint');
  }

  startAndPrint ( type : JobStartAndPrintTypeModel ) : Promise<any> {
    const modal = this.modalService.open(JobStartAndPrintComponent);

    modal.componentInstance.type = type;

    return modal.result;
  }
}
